import React, { useEffect, useState } from 'react';
import { FiX } from 'react-icons/fi';

const Verification = () => {
  const [passcode, setPasscode] = useState('');
  const [error, setError] = useState('');
  const verified = localStorage.getItem('verify')

  useEffect(() => {
    if(verified) {
        window.location.href=('assessmentdashboard')
    }
  }, [])

  const handleSubmit = () => {
    if (passcode === '6379') {
      localStorage.setItem('verify', 'true');
      window.location.href=('assessmentdashboard')
      setError('');
    } else {
      setError('Incorrect passcode. Please try again.');
    }
  };

  const handleInputChange = (e:any) => {
    setPasscode(e.target.value);
    if (error) setError(''); // Clear error when user starts typing
  };

  const handleKeyPress = (e:any) => {
    if (e.key === 'Enter') {
      handleSubmit();
    }
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center">
      <div className="bg-white rounded-xl shadow-xl p-8 w-96 max-w-[90vw] animate-fadeIn">
        <div className="space-y-6">
          {/* Header */}
          <div className="flex flex-col justify-center items-center text-center">
            <img src="newLogo.png" alt="" className='w-52 h-auto' />
            <p className="text-gray-500 mt-2">Please enter your 4-digit passcode to continue</p>
          </div>

          {/* Input Section */}
          <div className="space-y-4">
            <div className="relative">
              <input
                type="text"
                value={passcode}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
                maxLength={4}
                placeholder="Enter passcode"
                className="w-full px-4 py-3 text-center text-2xl tracking-widest rounded-lg border-2 border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all"
              />
              
              {/* Error Message */}
              {error && (
                <div className="mt-2 flex items-center gap-2 text-red-500 text-sm">
                  <FiX className="w-4 h-4" />
                  <span>{error}</span>
                </div>
              )}
            </div>

            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              className="w-full py-3 px-4 bg-green-500 hover:bg-green-700 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center space-x-2"
            >
              Verify Access
            </button>
          </div>

          {/* Footer Note */}
          <p className="text-center text-sm text-gray-500">
            If you've forgotten your passcode, please contact support
          </p>
        </div>
      </div>
    </div>
  );
};

export default Verification;